import createImmutableSelector from 'lib/immutable/selector'
import { IContacto } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getContacto = (state: any): IContacto => state.get('contactoReducer')

export const contactoSelector = createImmutableSelector(getContacto, (contacto) => contacto)
